<template>
  <img class="preview" :src="post.previewPic" />
</template>

<script>
export default {
  props: ['post'],
  mounted () {
    const img = this.$el

    const onloadFunc = () => {
      setTimeout(() => {
        this.$parent.$el.querySelector('.text-content').style.width = img.width + 'px'
        this.$el.style.width = img.width + 'px'
      })
    }

    img.onload = function () {
      onloadFunc()
    }

    if (img.complete) {
      onloadFunc()
    }
  }
}
</script>

<style lang="scss">
img.preview {
  width: 100%;
  @include breakpoint($d_small) {
    width: unset;
    min-width: 310px;
    max-width: 94%;
    min-height: 250px;
    /* max-height: 70vh; */
    max-height: 550px;
    &.swiper {
      max-width: 100%;
    }
  }
}
</style>